// CRO Header — universal desktop header rebuild (runs on every page)
(function(){
  if (window.__CRO_HEADER_LOADED__) return;
  window.__CRO_HEADER_LOADED__ = true;

  function rebuildDesktopHeader(){
    if (window.innerWidth < 990) return;
    var header = document.querySelector('header.header');
    if (!header || document.getElementById('cro-desktop-header')) return;
    var logoSrc = (document.querySelector('.header__heading-logo') || {}).src;
    var cartCount = document.querySelector('.cart-count-bubble span[aria-hidden]')?.textContent || '';

    var wrap = document.createElement('div');
    wrap.id = 'cro-desktop-header';
    wrap.innerHTML = ''
      + '<button type="button" class="cro-dh-menu" aria-label="Menu"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" width="24" height="24" aria-hidden="true"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg><span class="cro-dh-menu-text">Menu</span></button>'
      + '<form action="/search" method="get" role="search" class="cro-dh-search">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
        + '<input type="search" name="q" placeholder="Search products...">'
      + '</form>'
      + '<a href="/" class="cro-dh-logo">' + (logoSrc ? '<img src="' + logoSrc + '" alt="InstaCuppa">' : '<span>InstaCuppa</span>') + '</a>'
      + '<a href="https://wa.me/917330966937?text=Hi%2C%20I%20have%20a%20question" target="_blank" rel="noopener" class="cro-dh-help" aria-label="Need help — chat on WhatsApp">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>'
        + '<span class="cro-dh-help-text">Need help?</span>'
      + '</a>'
      + '<a href="/cart" class="cro-dh-cart" aria-label="Cart">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="28" height="28"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
        + '<span class="cro-dh-cart-text">Cart</span>'
        + (cartCount ? '<span class="cro-dh-cart-count">' + cartCount + '</span>' : '')
      + '</a>';
    header.insertBefore(wrap, header.firstChild);

    var menuBtn = wrap.querySelector('.cro-dh-menu');
    menuBtn.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.toggle('cro-menu-open');
      var details = document.querySelector('header-drawer details');
      if (details) details.open = document.body.classList.contains('cro-menu-open');
    });
    document.addEventListener('click', function(e){
      if (!document.body.classList.contains('cro-menu-open')) return;
      if (e.target.closest('.cro-dh-menu, .menu-drawer, header-drawer')) return;
      document.body.classList.remove('cro-menu-open');
      var d = document.querySelector('header-drawer details');
      if (d) d.open = false;
    });
  }


  // CX 2026-10-03: desktop category row under the header, built from the menu drawer's top-level links.
  // Undo: delete this function + its calls, and the "CX 2026-10-03 desktop category row" block in cro-pdp.css.
  function addCategoryRow(){
    if (window.innerWidth < 990) return;
    var head = document.getElementById('cro-desktop-header');
    if (!head || document.getElementById('cro-dh-cats')) return;
    var links = document.querySelectorAll('header-drawer .menu-drawer__menu.has-submenu > li > a, header-drawer .menu-drawer__menu.has-submenu > li > details > summary');
    if (!links.length) return;
    var nav = document.createElement('nav');
    nav.id = 'cro-dh-cats'; nav.setAttribute('aria-label', 'Shop by category');
    var here = location.pathname.replace(/\/$/, '');
    links.forEach(function(a){
      var href = a.getAttribute('href') || (a.closest('details') && a.closest('details').querySelector('a') || {}).getAttribute && a.closest('details').querySelector('a').getAttribute('href');
      if (!href) return;
      var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      var l = document.createElement('a'); l.href = href; l.textContent = text;
      try { if (new URL(href, location.origin).pathname.replace(/\/$/, '') === here) l.className = 'is-active'; } catch(e) {}
      nav.appendChild(l);
    });
    head.insertAdjacentElement('afterend', nav);
  }

  // Inline article date + Share button on same row
  function inlineArticleMeta(){
    var date = document.querySelector('.article-template time');
    var share = document.querySelector('.article-template__social-sharing');
    if (!date || !share) return;
    if (!document.querySelector('.cro-article-meta')) {
      var wrap = document.createElement('div');
      wrap.className = 'cro-article-meta';
      date.parentNode.insertBefore(wrap, date);
      wrap.appendChild(date);
      wrap.appendChild(share);
    }
    alignTitleWithContent();
  }

  // Align hero + title + meta to content's column (desktop only)
  function alignTitleWithContent(){
    if (window.innerWidth < 990) return;
    var content = document.querySelector('.article-template__content');
    var title = document.querySelector('.article-template h1');
    var meta = document.querySelector('.cro-article-meta');
    var hero = document.querySelector('.article-template__hero-container');
    if (!content || !title) return;
    var cr = content.getBoundingClientRect();
    var pr = title.parentElement.getBoundingClientRect();
    var leftOffset = Math.max(0, cr.left - pr.left);
    [title, meta].forEach(function(el){
      if (!el) return;
      el.style.setProperty('max-width', cr.width + 'px', 'important');
      el.style.setProperty('margin-left', leftOffset + 'px', 'important');
      el.style.setProperty('margin-right', 'auto', 'important');
    });
    // Hero is outside header.page-width — different parent, recompute offset
    if (hero) {
      var hp = hero.parentElement.getBoundingClientRect();
      var heroLeft = Math.max(0, cr.left - hp.left);
      hero.style.setProperty('max-width', cr.width + 'px', 'important');
      hero.style.setProperty('margin-left', heroLeft + 'px', 'important');
      hero.style.setProperty('margin-right', 'auto', 'important');
    }
  }
  window.addEventListener('resize', alignTitleWithContent);

  // Hide variant dropdowns that have only 1 option value (no real choice)
  function hideSingleOptionDropdowns(){
    document.querySelectorAll('.product-form__input--dropdown').forEach(function(wrap){
      var select = wrap.querySelector('select');
      if (!select) return;
      var realOptions = Array.from(select.options).filter(function(o){ return o.value && o.value.trim() !== ''; });
      wrap.style.display = realOptions.length <= 1 ? 'none' : '';
    });
  }

  // Unify font sizes on variant picker + quantity (beat Dawn's !important rules)
  function unifyPickerFonts(){
    var LABEL_SIZE = '15px';
    var VALUE_SIZE = '15px';
    var BTN_SIZE = '18px';
    document.querySelectorAll('.product-form__input--dropdown .form__label, .product-form__quantity .quantity__label, .product-form__quantity > label').forEach(function(el){
      el.style.setProperty('font-size', LABEL_SIZE, 'important');
      el.style.setProperty('font-weight', '600', 'important');
      el.style.setProperty('line-height', '1.4', 'important');
    });
    document.querySelectorAll('.product-form__input--dropdown select, .product-form__input--dropdown .select__select').forEach(function(el){
      el.style.setProperty('font-size', VALUE_SIZE, 'important');
    });
    document.querySelectorAll('.quantity__input').forEach(function(el){
      el.style.setProperty('font-size', VALUE_SIZE, 'important');
      el.style.setProperty('font-weight', '500', 'important');
    });
    document.querySelectorAll('.quantity__button').forEach(function(el){
      el.style.setProperty('font-size', BTN_SIZE, 'important');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      rebuildDesktopHeader();
      addCategoryRow();
      inlineArticleMeta();
      hideSingleOptionDropdowns();
      unifyPickerFonts();
    });
  } else {
    rebuildDesktopHeader();
    addCategoryRow();
    inlineArticleMeta();
    hideSingleOptionDropdowns();
    unifyPickerFonts();
  }
  setTimeout(function(){ rebuildDesktopHeader(); addCategoryRow(); }, 400);
  setTimeout(function(){ rebuildDesktopHeader(); addCategoryRow(); }, 1500);
  setTimeout(inlineArticleMeta, 400);
  setTimeout(hideSingleOptionDropdowns, 300);
  setTimeout(unifyPickerFonts, 300);
  setTimeout(unifyPickerFonts, 1200);
})();
